import { AxiosBackend } from '../HTTP/AxiosInstance'

const getSubscriptionOperationStatus = async (
  path: string,
  subscriptionId: string
): Promise<number> => {
  const response = await AxiosBackend.get<unknown>(path, {
    params: { subscriptionId }
  })

  if (!response.status) {
    throw new Error('Subscription operation did not return a status')
  }

  return response.status
}

export const deleteCurrentSubscription = (
  subscriptionId: string
): Promise<number> =>
  getSubscriptionOperationStatus('stripe/subscription/delete', subscriptionId)

export const cancelCurrentSubscription = (
  subscriptionId: string
): Promise<number> =>
  getSubscriptionOperationStatus('/stripe/subscription/cancel', subscriptionId)

export const renewCurrentSubscription = (
  subscriptionId: string
): Promise<number> =>
  getSubscriptionOperationStatus('/stripe/subscription/renew', subscriptionId)

export const upgradeCurrentSubscription = (
  subscriptionId: string
): Promise<number> =>
  getSubscriptionOperationStatus('/stripe/subscription/upgrade', subscriptionId)

export const getUserSubscriptionData = async (
  stripeCustomerId: string
): Promise<unknown> => {
  const response = await AxiosBackend.get<unknown>(
    '/stripe/subscription/sync',
    { params: { stripeCustomerId } }
  )

  if (response.status !== 200) {
    throw new Error('Subscription synchronization failed')
  }

  return response.data
}
